import { RouteDefinition } from '../shared/navigation/route-definition';
import { RoutePaths } from '../shared/navigation/route-paths';
import { ProductsPermissionResolver } from './products-permission.resolver';

export class ProductsRouteDefinition {
  public static getRoutes(): RouteDefinition {
    const menuItems: RouteDefinition = {
      path: RoutePaths.PRODUCTS,
      resolver: ProductsPermissionResolver,
      title: 'Products',
      icon: 'icon-products.svg',
      position: 5,
      children: [
        {
          path: RoutePaths.MODIFIERS,
          parentPath: RoutePaths.PRODUCTS,
          title: 'Modifiers',
          position: 0
        },
        {
          path: RoutePaths.TIMED_EVENTS,
          parentPath: RoutePaths.PRODUCTS,
          title: 'Timed Events',
          position: 1
        },
        {
          path: RoutePaths.CATEGORY,
          parentPath: RoutePaths.PRODUCTS,
          title: 'Categories',
          position: 2
        },
        {
          path: RoutePaths.INGREDIENTS,
          parentPath: RoutePaths.PRODUCTS,
          title: 'Ingredients',
          position: 3
        },
        {
          path: RoutePaths.LAYOUT,
          parentPath: RoutePaths.PRODUCTS,
          title: 'Products',
          position: 4
        },
        {
          path: RoutePaths.MENU,
          parentPath: RoutePaths.PRODUCTS,
          title: 'Menus',
          position: -1
        }
      ]
    };

    return menuItems;
  }
}
